(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('pfh-js');
  var els = document.querySelectorAll('.pfh-rv');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('pfh-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (e) { io.observe(e); });
})();

// Shopify repopulates native contact fields. Preserve only the extra project
// fields in this tab for a failed submission; do not store name/email/message.
(function () {
  function init(root) {
    root.querySelectorAll('.pfh-contact-form').forEach(function (form) {
      if (form.dataset.pfhDraftReady) return;
      form.dataset.pfhDraftReady = 'true';
      var key = 'pebble-hospitality-draft:' + form.id;
      var names = ['contact[Property]', 'contact[Location]', 'contact[Mattress quantity]', 'contact[Target timing]'];
      var maxAge = 30 * 60 * 1000;
      function clear() { try { sessionStorage.removeItem(key); } catch (_) {} }
      var card = form.closest('.pfh-inquiry-card');
      if (card.querySelector('.pfh-form-ok')) clear();
      try {
        var saved = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (saved && (typeof saved.at !== 'number' || Date.now() - saved.at > maxAge || saved.at > Date.now())) { clear(); saved = null; }
        if (saved && saved.values && card.querySelector('.pfh-form-err')) {
          names.forEach(function (name) {
            var field = form.elements.namedItem(name);
            var value = saved.values[name];
            if (field && typeof value === 'string' && !field.value) field.value = value.slice(0,160);
          });
        }
      } catch (_) { clear(); }
      function save() {
        var values = {};
        names.forEach(function (name) {
          var field = form.elements.namedItem(name);
          if (field) values[name] = field.value.slice(0,160);
        });
        try { sessionStorage.setItem(key, JSON.stringify({at:Date.now(),values:values})); } catch (_) {}
      }
      form.addEventListener('input',save);
      form.addEventListener('submit',save);
      form.addEventListener('reset',clear);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function (event) { init(event.target); });
})();
